export const NOTIFIER = '[Notifier]';

export const ENQUEUE_SNACKBAR = `${NOTIFIER} ENQUEUE_SNACKBAR`;
export const CLOSE_SNACKBAR = `${NOTIFIER} CLOSE_SNACKBAR`;
export const REMOVE_SNACKBAR = `${NOTIFIER} REMOVE_SNACKBAR`;
